import { render } from "./LightboxProductsRevenueSkeleton.vue?vue&type=template&id=4aa202dd&scoped=true"
import script from "./LightboxProductsRevenueSkeleton.vue?vue&type=script&lang=js"
export * from "./LightboxProductsRevenueSkeleton.vue?vue&type=script&lang=js"

import "./LightboxProductsRevenueSkeleton.vue?vue&type=style&index=0&id=4aa202dd&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa202dd"]])

export default __exports__